import React from 'react';
export function CodeIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.005 19a1.01 1.01 0 01-.9-1.45l6-12c.25-.49.85-.69 1.34-.45.49.25.69.85.45 1.34l-6 12c-.18.35-.53.55-.9.55l.01.01zM6 17c-.26 0-.51-.1-.71-.29l-4-4a.996.996 0 010-1.41l4-4A.996.996 0 116.7 8.71L3.41 12l3.29 3.29a.996.996 0 01-.71 1.7L6 17zM17.25 16.71c.2.19.45.29.71.29l-.01.01c.26 0 .51-.09.71-.29l4-4a.996.996 0 000-1.41l-4-4a.996.996 0 10-1.41 1.41l3.29 3.29-3.29 3.29a.996.996 0 000 1.41z"
  }));
}